// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2gItx","productName":"Table_productName__1yv3W"};